export const getAdminDashboardTab = state => state.adminData.activeTab;
export const getAdminReports = state => state.adminData.adminReportsList;
export const getAdminReportCategory = state => state.adminData.reportCategory;
export const getUserGuide = state => state.adminData.file;
export const getUserGuideFilename = state => state.adminData.filename;
export const getAdminTabStatus = state => state.adminData.tabStatus;
